import { STATE_LABELS, STATES } from '../domain/skills.js';

export function Avatar({ profile, big }) {
  return <div className={`avatar c-${profile.color} ${big ? 'big' : ''}`} aria-hidden>{profile.name.slice(0, 1).toUpperCase()}</div>;
}

export function StateChip({ state }) {
  return <span className={`chip s-${state}`}>{STATE_LABELS[state]}</span>;
}

export function Ladder({ state }) {
  const idx = STATES.indexOf(state);
  return (
    <div>
      <div className="ladder" aria-label={`Ladder: ${STATE_LABELS[state]}`}>
        {STATES.map((s, i) => <div key={s} className={`rung ${i <= idx && idx > 0 ? 'on' : ''}`} />)}
      </div>
      <div className="ladder-labels"><span>Learning</span><span>Independent</span><span>Can teach</span></div>
    </div>
  );
}
